module.exports = __webpack_public_path__ + "img/pennyknock.b2f0326e.svg";